/* eslint-disable no-param-reassign */
import { AnniProjectMessage } from '../AnniProjectPopupInterface';
import {
  anniversaryProjectVo,
  AnniversaryProjectControllerService,
} from '@/__generated__/FrontApi';
import IconClose from '@/assets/img/icons/btn_close@2x.png';
import IconMsg from '@/assets/img/icons/ico_letter_blue@2x.png';
import IconMsg2 from '@/assets/img/icons/ico_msg@2x.png';
import inputTextImg2 from '@/assets/img/involve/box_shape_blue.jpg';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { useUserStore } from '@/stores/UserStore';
import React, { FC, useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';

const ContentSection = styled.div`
  margin: 30px 0;
  max-width: 768px;
  display: inline-block;
  text-align: initial;
  width: 100%;

  &.no-data {
    text-align: center;
  }
  .top-dec {
    margin-top: 32px;
  }

  .show-msg {
    margin-top: 35px;
  }

  ${breakpoint(`mobile`)} {
    padding: 32px 0 40px;
  }
`;

const H3 = styled.h3`
  font-size: 22px;
  color: #1cabe2;
  font-weight: bold;
  letter-spacing: -0.88px;
  margin-bottom: 15px;

  ${breakpoint(`mobile`)} {
    font-size: 16px;
  }
`;

/* <Text> 안에 서로 다른 3개의 속성에 따른 list style값 */
const Text = styled.span<{
  listStyle?: boolean;
  titStyle?: boolean;
  titStyle2?: boolean;
}>`
  display: inline-block;
  position: relative;
  line-height: 1.7;
  ${({ listStyle }) => {
    if (listStyle) {
      return `
      &::before {
        content: '';
        display: inline-block;
        width: 5px;
        height: 5px;
        background: #1cabe2;
        border-radius: 100%;
        vertical-align: middle;
        margin: -4px 10px 0 4px;

        ${breakpoint(`mobile`)} {
          width: 4px;
          height: 4px;
        }
      }
      `;
    }
    return ``;
  }}
  ${({ titStyle }) => {
    if (titStyle) {
      return `
      &::before {
        content: '';
        display: inline-block;
        width: 18px;
        height: 13px;
        background: url(${IconMsg}) no-repeat;
        background-size: contain;
        vertical-align: middle;
        margin: -2px 10px 0 2px;
      }
        `;
    }
    return ``;
  }}
  ${({ titStyle2 }) => {
    if (titStyle2) {
      return `
      &::before {
        content: '';
        display: inline-block;
        width: 18px;
        height: 15px;
        background: url(${IconMsg2}) no-repeat;
        background-size: contain;
        vertical-align: middle;
        margin: -2px 10px 0 2px;
      }
        `;
    }
    return ``;
  }}
`;

const Board = styled.div`
  position: relative;
  &::after {
    content: '';
    display: block;
    width: 43px;
    height: 36px;
    background: url(${inputTextImg2}) no-repeat;
    background-size: contain;
    position: absolute;
    top: 0;
    right: 0;
  }

  .show-msg-box {
    max-height: 612px;
    border: 1px solid #1cabe2;
    padding: 35px 14px 26px;
    margin-top: 17px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 4px;
      background: #e2e3e3;
    }
    &::-webkit-scrollbar-thumb {
      background: #1cabe2;
    }

    div {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      border-bottom: 1px solid #e5e6e8;
      padding: 20px 0 17px;
      p {
        width: 100%;
        color: #828385;

        &.block {
          color: #cfcfcf;
        }

        ${breakpoint(`mobile`)} {
          margin-bottom: 8px;
        }
      }
      span:first-of-type {
        color: #2d2926;
        font-weight: bold;
      }
      span:last-of-type {
        color: #1cabe2;
        font-weight: bold;
      }
    }

    .btn-del {
      vertical-align: top;
      display: contents;

      > img {
        width: 20px;
        height: 20px;
        margin: 0 0 0 10px;
      }

      &.btn-del-hide {
        display: none;
      }
      &.btn-del-error::after {
        content: '메시지 삭제에 실패했습니다.';
        color: #e2231a;
        font-size: 14px;
        margin: 0 0 0 5px;
      }
    }

    ${breakpoint(`mobile`)} {
      margin-top: 6px;
    }
  }
  ${breakpoint(`mobile`)} {
    margin-top: 8px;
  }
`;

const AnniGiftList: FC<{ action: string; datas: any }> = ({ datas }) => {
  const [items, setItems] = useState<anniversaryProjectVo>(datas);
  const userStore = useUserStore();
  useEffect(() => {
    setItems(datas);
  }, [datas, userStore]);

  const handlerBlockMessage = useCallback(async (el: any, id: number) => {
    // 폼데이터로 변환
    const finalData = {
      anniIndex: id,
      aprjtIdx: items.aprjtIdx,
    };
    const btn = el.currentTarget;

    try {
      // blockData
      const submitRes: any = await AnniversaryProjectControllerService.updateAnniversaryGiftMessageBlockUsingPost(
        finalData,
      );

      if (submitRes?.resultCode === 'success') {
        // success
        btn.parentNode.textContent = AnniProjectMessage.GiftBlockMsg;
        // btn.className = 'btn-del btn-del-hide';
      } else {
        // error
        btn.className = 'btn-del btn-del-error';
      }
    } catch (e) {
      // exception
      btn.className = 'btn-del btn-del-error';
    }
  }, []);

  if (items === null)
    return (
      <ContentSection className="no-data">
        찾을 수 없는 페이지입니다.
      </ContentSection>
    );

  return (
    <ContentSection>
      <div className="show-msg">
        <H3>메시지 보기</H3>
        <Text titStyle>
          <b>기념 메시지 보기</b>
        </Text>
        <Board>
          <div className="show-msg-box">
            {items?.arrGift.length === 0 ? (
              <>작성된 메시지가 없습니다.</>
            ) : (
              items?.arrGift.map((row: any) => (
                <div key={row.rowNum}>
                  <p className={`${row.blockMessageYn === 'Y' ? 'block' : ''}`}>
                    {row.blockMessageYn === 'Y'
                      ? AnniProjectMessage.GiftBlockMsg
                      : row.story}
                    {items.registerId === userStore.user?.userId &&
                    row.blockMessageYn !== 'Y' ? (
                      <>
                        {/** 프로젝트생성자이고 차단되지 않는 메시지일 경우 */}
                        <button
                          type="button"
                          className="btn-del"
                          title="메시지 감추기"
                          onClick={(el) => {
                            handlerBlockMessage(el, row.anniIndex);
                          }}
                        >
                          <img src={IconClose} alt="" />
                        </button>
                      </>
                    ) : (
                      <>{/** 프로젝트 생성자가 아닐경우 */}</>
                    )}
                  </p>
                  <span>{row.memberName || '비공개'}</span>
                  <span>
                    {row.totalAmount
                      ? `${row.totalAmount.toLocaleString()}원`
                      : '비공개'}
                  </span>
                </div>
              ))
            )}
          </div>
        </Board>
      </div>
    </ContentSection>
  );
};

export default AnniGiftList;
